import React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { isFeatureEnabled } from "@editor/infra/featureFlags";

import { useParams } from "react-router-dom";

import { ProjectWebsocketProvider } from "../react-editor/components/ProjectWebsocketProvider";
import FunnelEditor from "./components/FunnelEditor";

function Funnel() {
  const isReaplo = isFeatureEnabled("reaplo");
  const projectId = useCurrentProjectId();
  const { funnelId } = useParams();

  if (!isReaplo) {
    window.location.href = `/projects/${projectId}`;
    return null;
  }

  if (!funnelId) {
    return null;
  }

  return (
    <ProjectWebsocketProvider projectId={projectId ?? ""}>
      <div className="flex gap-3 h-full w-full">
        <FunnelEditor funnelId={funnelId} />
      </div>
    </ProjectWebsocketProvider>
  );
}

export default Funnel;
